<template>
    <Paper class="notice">
        <!-- 头部-搜索、查询新增按钮 -->
        <search @closeChange='search' ref="newsSearch" :searchBlock='searchBlock'></search>
        <!-- 表格 -->
        <div class="notice-table">
            <notice-table  :tableData='tableData' @changeStauts='changeStauts' @changeNews="changeNews"></notice-table>
        </div>
        <div class="notice-add">
            <el-button @click="newPush" icon="el-icon-plus" type="primary" size="mini" class="new-button">
                {{$translate('lang.E3202102260005', { defaultText: '新增' })}}
            </el-button>
        </div>
        <pageList v-if="pageState" :pageMenu="pageMenu" @changeCurrent="currentDom" @changeSize="sizeDom" class="notice-page"></pageList>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import search from './noticeSearch';
import noticeTable from './noticeTable';
import pageList from '../../../components/systemComponent/pageList';
import { searchNotic, changeNewsState } from '../../../api/systemManagementApi';
export default {
    name: 'notice',
    data() {
        return {
            pageState: true,
            searchBlock: false,
            tableData: [],
            pageMenu: {
                totalCount: 0,
                currentPage: 1,
                pageNo: 1, // 初始页
                pageSize: 10, // 每页个数
                pageSizes: [10, 20, 30, 40]
            }
        };
    },
    methods: {
        // 分页1
        currentDom(val) {
            this.pageMenu.pageNo = val;
            this.getData();
        },
        // 分页2
        sizeDom(val) {
            this.pageMenu.pageSize = val;
            this.getData();
        },
        // 搜索-查询
        search() {
            this.pageState = false;
            this.pageMenu.pageNo = 1;
            this.searchBlock = true;
            this.getData();
            this.$nextTick(() => {
                this.pageState = true;
            });
        },
        // 获取数据
        getData() {
            const parms = {
                subject: this.$refs.newsSearch.queries.subject,
                contentType: this.$refs.newsSearch.queries.state,
                pageNo: this.pageMenu.pageNo,
                pageSize: this.pageMenu.pageSize,
                orderBy: 'updateTime',
                orderByType: 'desc'
            };
            if (!parms.contentType) {
                parms.contentType = '1,2';
            }
            if (this.$refs.newsSearch.timeHorizon) {
                parms.startTime = this.$refs.newsSearch.timeHorizon[0];
                parms.endTime = this.$refs.newsSearch.timeHorizon[1];
            } else {
                parms.startTime = '';
                parms.endTime = '';
            }
            for (var i in parms) {
                if (parms[i] === '') {
                    delete parms[i];
                }
            }
            searchNotic(parms).then(res => {
                if (res.code === '0') {
                    this.tableData = res.data.list;
                    this.pageMenu.totalCount = res.data.totalCount;
                }
                this.searchBlock = false;
            }).catch(() => {
                this.searchBlock = false;
            });
        },
        // 状态修改按钮
        changeStauts(row) {
            this.$confirm(this.$translate('lang.EXC202102260004', { defaultText: '此操作将进行状态更改, 是否继续?' }),
                this.$translate('lang.E3202102220028', { defaultText: '提示' }), {
                    confirmButtonText: this.$translate('lang.E3202101270001', { defaultText: '确定' }),
                    cancelButtonText: this.$translate('lang.E3202101270002', { defaultText: '取消' }),
                    type: 'warning'
                })
                .then(() => {
                    if (row.state === 0) {
                        row.state = 1;
                    } else {
                        row.state = 0;
                    }
                    changeNewsState({
                        id: row.id,
                        subject: row.subject,
                        version: row.version,
                        state: row.state,
                        contentType: row.contentType
                    }).then(res => {
                        if (+res.code === 0) {
                            this.$message.success(this.$translate('lang.EXC202102260002', { defaultText: '更改成功!' }));
                            this.search();
                        }
                    }).catch(() => {
                        this.$message.warning(this.$translate('lang.E3202103170018', { defaultText: '变更失败!' }));
                        this.search();
                    });
                })
                .catch(() => {
                });
        },
        // 修改按钮
        changeNews(row) {
            this.$router.push({
                path: '/changeNotice',
                query: { id: row.id }
            });
        },
        // 新增按钮
        newPush() {
            this.$router.push({
                path: '/changeNotice'
            });
        }

    },
    components: {
        Paper,
        pageList,
        search,
        noticeTable
    },
    mounted() {
        this.getData();
    },
    activated() {
        this.getData();
    }
};
</script>
<style lang="less">
.notice{
    // 搜索框-标题
    // 搜索框-input长度
    .notice-search-input{
    flex: 1;
        // 时间范围
        .notice-search-input-date{
            width: 100%;
            min-width: 200px;
        }
    }
    .notice-add{
        float: left;
        margin-top: 20px;
    }
    // 表格样式
    .notice-table{
        .el-table {
        height: calc(100vh - 180px) !important;
        }
        .row-bg {
        margin-top: 20px;
        }
    }
    // 底部分页
    .notice-page{
        text-align: right;
        margin-top:20px;
    }

}
</style>